import { BilSnackbarComponent } from '@core/components/bil-snackbar/bil-snackbar.component';
import { BilEventSnackbarOpen } from '@app/core/services/bil-event-broker/bil-event-broker-arguments/bil-event-snackbar-open';
import { BilEventSnackbarClose } from '@app/core/services/bil-event-broker/bil-event-broker-arguments/bil-event-snackbar-close';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/snack-bar";
import * as i2 from "../bil-event-broker/bil-event-broker.service";
import * as i3 from "../../configs/bil-snackbar-config.service";
export class BilSnackbarService {
    constructor(snackBar, eventBroker, snackbarConfigService) {
        this.snackBar = snackBar;
        this.eventBroker = eventBroker;
        this.snackbarConfigService = snackbarConfigService;
    }
    startListening() {
        this.eventBroker.subscribe((event) => {
            this.close();
            if (event.duration) {
                this.open(event.message, event.type, event.duration);
            }
            else {
                this.open(event.message, event.type);
            }
        }, BilEventSnackbarOpen.EventSelector);
        this.eventBroker.subscribe((event) => {
            this.close();
        }, BilEventSnackbarClose.EventSelector);
    }
    open(message, type, duration) {
        const config = this.snackbarConfigService.getSnackbarConfig();
        config.duration = duration ? duration : config.duration;
        config.data = { text: message, type: type };
        config.panelClass = ['bil-snackbar-' + type];
        this.snackBarRef = this.snackBar.openFromComponent(BilSnackbarComponent, config);
    }
    close() {
        if (this.snackBarRef) {
            this.snackBarRef.dismiss();
        }
    }
}
BilSnackbarService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BilSnackbarService_Factory() { return new BilSnackbarService(i0.ɵɵinject(i1.MatSnackBar), i0.ɵɵinject(i2.BilEventBrokerService), i0.ɵɵinject(i3.BilSnackbarConfigService)); }, token: BilSnackbarService, providedIn: "root" });
